import { deleteApi, get } from "../GenericServices";

const ContractualRevenueDocument = {
  downloadDocumentContractualRevenue: (id) => {
    return get(`contractual-revenue-document/${id}/download`, {}, "blob");
  },
  deleteDocumentContractualRevenue: (id) => {
    return deleteApi(`contractual-revenue-document/${id}`);
  },
};

export default ContractualRevenueDocument;
